module.exports = __webpack_public_path__ + "static/media/logo.fb495ebd.png";